import Vue from 'vue';
import TryNow from './components/try-now';
import SampleContent from './components/sample-content';

Vue.component('try-now', TryNow);
Vue.component('sample-content', SampleContent);